import React, { useState, useEffect } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Typography } from "@mui/material";


const Banner = ({displayAll=false, closeBanner=false}) => {
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        if (closeBanner) {
            const timer = setTimeout(() => {
                setIsHidden(true);
            }, 500); // Match the transition duration
            return () => clearTimeout(timer);
        } else {
            setIsHidden(false);
        }
    }, [closeBanner]);

    if (isHidden) {
        return <div />;
    }

    return (
        <Box
            sx={{
                width: '100%',
                transform: closeBanner ? 'translateY(-100%)' : 'translateY(0)',
                transition: 'transform 0.5s ease-in-out',
                // margin: '0 auto',
                // Your existing header styles...
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: displayAll ? '400px' : '150px', // Adjust height as needed
                    overflow: 'hidden',
                    
                }}
            >

                
                <img 
                    src="https://picagroup.com.au/wp-content/uploads/2024/12/Forms-and-applications-iStock-1766782826-scaled-1.jpg" 
                    alt="Banner" 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        // filter: 'brightness(0.9)' // Slightly dim the image
                    }}
                />
                <Box
                    sx={{
                        width: '90%',
                        maxWidth: '1280px',
                        margin: '0 auto'
                    }}>
                
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 1,
                        backgroundColor: 'white',
                        padding: '25px 30px 25px 0',
                        borderLeft: '10px solid #FFB81C',
                    }}
                >
                    <Typography
                        variant="h4"
                        color= 'primary'
                        sx={{
                            
                            // fontSize: '2.5rem',
                            fontWeight: 500,
                            
                            paddingLeft: '20px',
                        }}
                    >
                        Inspection of scheme records
                    </Typography>
                </Box>
                </Box>
            </Box>
        

        </Box>
    )
}

export default Banner;

